// import Search from "./ModelSearch";
import { Button, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
	getListInvestmentAsync,
	selectInvestmentList,
	selectInvestmentTotal,
} from "./redux/investment.slice";
import { subText, translate } from "utils";
import {
	FormRequest,
	FormRequestQueryParams,
	FORM_REQUEST_STATUS,
} from "../form-request/type";
import useBreadcrumb from "hooks/useBreadcrumb";
import { APP_PATH } from "constants/path";
import {
	selectInvestmentFilter,
	setInvestmentFilter,
} from "store/filter/index.slice";
import { FormRequestStatusElements } from "../form-request/constant";
import Search from "./InvestmentSearch";
import FormRequestTable from "../form-request/FormRequestTable";

export default function Investments() {
	const dispatch = useDispatch();
	const investments = useSelector(selectInvestmentList);
	const investmentTotal = useSelector(selectInvestmentTotal);
	const { setBreadCrumbs } = useBreadcrumb();
	const investmentFilter = useSelector(selectInvestmentFilter);
	const [query, setQuery] = useState({
		...investmentFilter,
	});
	const [isLoading, setIsLoading] = useState(false);

	const getData = (query: FormRequestQueryParams) => {
		const callback = () => {
			setIsLoading(false);
			setQuery({ ...query });
			dispatch(setInvestmentFilter({ ...query }));
		};
		setIsLoading(true);
		dispatch(
			getListInvestmentAsync({
				query: { ...query },
				callback,
			}),
		);
	};
	useEffect(() => {
		getData(query);
		setBreadCrumbs([
			{
				label: translate("Request investment"),
				path: APP_PATH.investment,
				icon: <UserSwitchOutlined />,
			},
		]);
	}, []);

	const columns: ColumnsType<FormRequest> = [
		{
			title: translate("NO"),
			dataIndex: "",
			key: "NO",
			width: "50px",
			align: "center",
			render: (value, record, index: number) => (
				<p>{query.skip * query.take + index + 1}</p>
			),
		},
		{
			title: translate("Name"),
			dataIndex: "name",
			key: "name",
			render: (name, record) => {
				return (
					<Link to={`${APP_PATH.investment}/${record._id}`}>
						<p>{name}</p>
					</Link>
				);
			},
		},
		{
			title: translate("Phone number"),
			dataIndex: "phoneNumber",
			key: "phoneNumber",
		},
		{
			title: translate("Email"),
			dataIndex: "email",
			key: "email",
		},
		{
			title: translate("Description"),
			dataIndex: "description",
			key: "description",
			render: text => <p className="max-w-[200px]">{subText(text, 100)}</p>,
		},
		{
			title: translate("Status"),
			dataIndex: "status",
			key: "status",
			render: (value: FORM_REQUEST_STATUS) => {
				const statusData = FormRequestStatusElements[value];
				return (
					statusData && (
						<div className="flex justify-center flex-wrap">
							<Tag color={statusData.color}>{translate(statusData.label)}</Tag>
						</div>
					)
				);
			},
		},
		{
			title: translate("Action"),
			key: "action",
			dataIndex: "_id",
			render: (id: string) => (
				<Link to={`${APP_PATH.investment}/${id}`}>
					<Button
						shape="circle"
						size="middle"
						type="primary"
						className={
							"m-1 flex items-center justify-center border-0 bg-blue-400  text-xs"
						}
						icon={<EditOutlined />}
					/>
				</Link>
			),
		},
	];

	return (
		<div className="h-full bg-white p-5 my-5 fade-in">
			<Search query={query} setQuery={setQuery} getList={getData} />
			<div className="mt-10">
				<FormRequestTable
					dataSource={investments}
					columns={columns}
					getData={getData}
					loading={isLoading}
					query={query}
					total={investmentTotal}
				/>
			</div>
		</div>
	);
}
